import { User } from "../../section/-account/model/user";
import { LMS_USER } from "../../component/constant";
import { dateTimeReviver } from "../helper/json-helper";

export function getAccessToken(): string | null | undefined {
    const user: User | null = JSON.parse(localStorage.getItem(LMS_USER)!, dateTimeReviver);
    return user?.accessToken
}
